// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"822bae53","2561":"8d3ceee0","2887":"2f79e2a9","5090":"89038f20"}[chunkId] + ".css";
};